import type { TypographyProps } from "@mui/material";
import { Typography } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  maxLines: number;
  typographyProps?: TypographyProps;
}
const TypographyMultilineEllipsis = ({
  maxLines,
  typographyProps,
  children,
  ...rest
}: PropsWithChildren<Props> & TypographyProps) => {
  const { sx, ...props } = typographyProps ?? {};

  return (
    <Typography
      {...props}
      {...rest}
      sx={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        WebkitLineClamp: maxLines,
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};

export default TypographyMultilineEllipsis;
